import { DeleteIcon } from '@chakra-ui/icons';
import { ParseResult } from 'papaparse';
import React, { useRef, useState } from 'react';
import { CSVReader } from 'react-papaparse';

import {
  CmBox,
  CmButton,
  CmFlex,
  CmIconButton,
  CmInput,
  CmInputGroup,
  CmInputLeftElement,
  CmInputRightElement,
  CmText,
} from '@/components/uiParts';
import { ImportPos, RegisterPos } from '@/domain/models/Pos';
import { PosDataFactory } from '@/pages/externals/pos-connect/factories';
import { usePosUpload } from '@/services/Pos/hooks';

interface File {
  lastModified: number;
  lastModifiedDate: Date;
  name: string;
  size: number;
  type: 'text/csv';
  webkitRelativePath: string | null;
  '[[Prototype]]': File;
}

interface Props {
  posProviderId: number;
  reFetchPosItems: () => void;
}

export const CSVImportReader: React.FC<Props> = ({
  posProviderId,
  reFetchPosItems,
}) => {
  const [isDisabled, setIsDisabled] = useState<boolean>(true);
  const [isFraudulentCSV, setIsFraudulentCSV] = useState<boolean>(false);
  const [registerPosData, setRegisterPosData] = useState<RegisterPos[]>();

  const posDataUpload = usePosUpload();
  const buttonRef = useRef<CSVReader<HTMLButtonElement>>(null);

  const handleOpenDialog = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    if (buttonRef.current) {
      buttonRef.current.open(event);
    }
  };

  const isValid = (data: Array<ParseResult<unknown>>): boolean => {
    return data[0].data.includes('meta_data');
  };

  const handleOnFileLoad = (data: Array<ParseResult<unknown>>) => {
    if (!isValid(data)) {
      setIsDisabled(true);
      setIsFraudulentCSV(true);
      return;
    }
    setIsDisabled(false);
    setIsFraudulentCSV(false);
    setRegisterPosData(PosDataFactory.createFromImportCSV(data as ImportPos[]));
  };

  const handleRegisterPos = async (providerId: number) => {
    if (!registerPosData) return;
    await posDataUpload(providerId, registerPosData);
    alert('アップロードされました');
    handleRemoveFile();
    reFetchPosItems();
  };

  const handleRemoveFile = () => {
    if (buttonRef.current) {
      buttonRef.current.removeFile();
      setIsFraudulentCSV(false);
      setRegisterPosData(undefined);
      setIsDisabled(true);
    }
  };

  return (
    <CmBox>
      <CmFlex ml={40}>
        {isFraudulentCSV && (
          <CmText fontWeight="bold" color="primaryRed">
            不正な形式のCSVファイルです
          </CmText>
        )}
      </CmFlex>
      <CmFlex>
        <CSVReader ref={buttonRef} onFileLoad={handleOnFileLoad} noClick noDrag>
          {({ file }: { file: File }) => (
            <CmInputGroup size="md">
              <CmInputLeftElement width="12rem" justifyContent="start">
                <CmButton onClick={handleOpenDialog}>CSVアップロード</CmButton>
              </CmInputLeftElement>
              <CmInput
                pl="11rem"
                type="text"
                placeholder="camel.csv"
                defaultValue={file ? file.name : ''}
                isReadOnly={true}
              />
              <CmInputRightElement>
                <CmIconButton
                  aria-label="delete-file"
                  backgroundColor="transparent"
                  colorScheme="white"
                  color="primaryDarkBlue"
                  fontSize={24}
                  icon={<DeleteIcon />}
                  onClick={handleRemoveFile}
                />
              </CmInputRightElement>
            </CmInputGroup>
          )}
        </CSVReader>
        {/*
         // @ts-ignore TS2590 */}
        <CmButton
          ml={8}
          onClick={() => handleRegisterPos(posProviderId)}
          disabled={isDisabled}
        >
          CSV登録
        </CmButton>
      </CmFlex>
    </CmBox>
  );
};
